"use strict";
/**
 * This component implements SearchBox
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../codegen/Messages");
var Spinner_1 = require("../pure-components/Spinner");
var Input_1 = require("../components/form/inputs/Input");
var util_1 = require("../utils/util");
var warning_1 = require("../utils/warning");
// Search Icon Element
var searchIcon = (React.createElement("span", { "data-oui-search-icon": "", key: "search-icon" }));
// Search Spinner Element
var searchSpinner = (React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.Small, additionalClassNames: ["oui-search-icon"] }));
/**
 * OUI search box component.
 *
 * @oui-component SearchBox
 */
var SearchBox = function (props) {
    // Submit Event handler
    var onKeyPress = function (e) {
        if (e.key === "Enter" && props.onEnterKey) {
            e.preventDefault();
            props.onEnterKey(e);
        }
    };
    var ariaLabel = props.ariaLabel, isSearching = props.isSearching, onEnterKey = props.onEnterKey, label = props.label, placeholder = props.placeholder, rest = __rest(props, ["ariaLabel", "isSearching", "onEnterKey", "label", "placeholder"]);
    warning_1.default(ariaLabel !== undefined, "`ariaLabel` is being deprecated, use `label` instead");
    var inputProps = __assign({}, rest, (onEnterKey && { onKeyPress: onKeyPress }), util_1.ariaProps({ label: label || ariaLabel }));
    return (React.createElement("div", { className: "oui-search oui-search-default" },
        isSearching ? searchSpinner : searchIcon,
        React.createElement(Input_1.default, __assign({}, inputProps, { placeholder: placeholder || Messages.Search.placeholder() + "...", type: Input_1.InputTypes.Text }))));
};
SearchBox.defaultProps = {
    disabled: false,
    label: "search",
    autoFocus: false
};
exports.default = SearchBox;
//# sourceMappingURL=SearchBox.js.map